
import { createTodayDateTimeAtHour } from "../../Helpers/dateFormating";
import { api } from "../config";


export const profilePrograms = {
  Actions: {
    GetDevices: async () => {
        try {
        
            const response = await api.get("Scheduling/get-devices");
            return response.data.data;
            

        } catch (error) {
            console.error(error);
        }
    },

    SunsetRise: async (selectedDevices) => {
        try {
            const response = await api.put("Scheduling/sunset-sunrise-activation",
                selectedDevices,
            );
            return response;
        } catch (error) {
            console.error(error);
        }
    },

    AllProgramsOff: async () => {
        try {
          
            const response = await api.post("Scheduling/deactivate-all-programs");
            return response;
  
        } catch (error) {
            console.error(error);
        }
    },

    SaveNewProgram: async (program) => {
        try {
            const response = await api.post("Scheduling/save-new-program", { 
                scheduleName : program.scheduleName,  
                phase1hoursel : createTodayDateTimeAtHour(program.phase1hoursel.hour()), 
                sliderPhase1 : program.sliderPhase1, 
                phase2hoursel : createTodayDateTimeAtHour(program.phase2hoursel.hour()), 
                sliderPhase2 : program.sliderPhase2, 
                phase3hoursel : createTodayDateTimeAtHour(program.phase3hoursel.hour()), 
                sliderPhase3 : program.sliderPhase3, 
                phase4hoursel : createTodayDateTimeAtHour(program.phase4hoursel.hour()), 
                sliderPhase4 : program.sliderPhase4, 
            });
            return response;
  
        } catch (error) {
          console.error(error);
        }
    },

    GetAllPrograms: async (page = 0, pageSize = 10) => {
        try {
        
            const response = await api.get("Scheduling/all-programs", 
                {
                    params : {
                        page : page,
                        pageSize: pageSize
                    }
                });
            return response.data;

        } catch (error) {
            console.error(error);
        }
    },

    ActivateProgram: async (programId, selectedDevices) => {
        try {
            const response = await api.put("Scheduling/activate-program", {
                programId : programId,
                deviceIds: selectedDevices,
            });
            return response;
        } catch (error) {
            console.error(error);
        }
    },

    DeleteProgram: async (programId) => {
        try {
            const response = await api.delete(`Scheduling/delete/${programId}`);
            return response;
        } catch (error) {
            console.error(error);
        }
    },

    
  },
};